const RAW_API_BASE =
  process.env.NEXT_PUBLIC_API_URL || "https://api.gritizer.com";

export const API_BASE_URL = RAW_API_BASE.endsWith("/api")
  ? RAW_API_BASE.replace(/\/+$/, "") // ensure no trailing slash duplicates
  : `${RAW_API_BASE.replace(/\/+$/, "")}/api`;



